module.exports = __webpack_public_path__ + "9b03e5da08053f5b1bd2bafb5205c95d.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/161.png
// module id = 1756
// module chunks = 2